import React from "react";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import i18n from "../../../i18n/i18n";
import {DateUtils} from "../../../helpers/dateUtils";
import {ValidatedValue} from "../../../helpers/validatedValue";
import Report from "../report/report";
import {Utils} from "../../../helpers/utils";
import {SeaFerriesSummaryService} from "../../services/seaFerriesSummaryService";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {SeaFerriesSummaryModel} from "../../models/seaFerriesSummary";
import {LoadingType, LoadingTypeFirstLetter} from "../../../documents/models/enums";
import {IPaginationStore} from "../../../common/stores/paginationStore";
import {storesContext} from "../../../common/stores/stores";
import {DropDownModel} from "../../../common/models/dropDown";

interface SeaFerriesSummaryState {
    selectedYear: ValidatedValue<string>;
    selectedMonth: ValidatedValue<string>;
    isSubmitButtonBlocked: boolean;
    isReportGenerated: boolean;
    generatedReport: SeaFerriesSummaryModel[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    currentPage: number;
}

export default class SeaFerriesSummary extends React.Component <any, SeaFerriesSummaryState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            selectedYear: new ValidatedValue(new Date().getFullYear().toString()),
            selectedMonth: new ValidatedValue((new Date().getMonth()+1).toString()),
            isSubmitButtonBlocked: false,
            isReportGenerated: false,
            generatedReportResponse: undefined,
            generatedReport: undefined,
            currentPage: 0
        };
    }

    public render(): JSX.Element {
        const properties = ["shipownerName", "ferryName", "loadingType", "billOfLading", "monthOut", "monthIn",
            "calculatedMonth", "yearOut", "yearIn", "calculatedYear"];
        const headers = properties.map(key => i18n.t("reports.seaFerriesSummary.headers." + key));

        return (
            <Report
                filters={this.renderFilters()}
                onGenerateReport={this.onGenerateReport.bind(this)}
                generatedReport={this.state.generatedReport}
                generatedReportResponse={this.state.generatedReportResponse}
                isReportGenerated={this.state.isReportGenerated}
                reportTestId="sea-ferries-summary"
                reportProperties={properties}
                reportHeaders={headers}
                reportTableRenderCell={this.renderCell}
                currentPage={this.state.currentPage}
                reportService={SeaFerriesSummaryService}
                isSummaryReportGenerated={false}
                isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                selectedFilters={
                    {
                        year: this.state.selectedYear.value,
                        month: this.state.selectedMonth.value
                    }
                }
                summaryCurrentPage={0}
                summaryNumberOfElements={0}
            />
        );
    }

    private renderFilters(): JSX.Element {
        return (
            <>
                <DropDown
                    label={i18n.t("reports.seaFerriesSummary.filters.year")}
                    items={this.yearsToDropDownMap}
                    validatedValue={this.state.selectedYear}
                    testId="filters-year"
                    withoutSort
                />
                <DropDown
                    label={i18n.t("reports.seaFerriesSummary.filters.month")}
                    items={this.monthsToDropDownMap}
                    validatedValue={this.state.selectedMonth}
                    testId="filters-month"
                    withoutSort
                />
            </>
        );
    }

    private renderCell(row: any, property: string): JSX.Element {
        if (property === "loadingType") {
            return <>{LoadingTypeFirstLetter[row[property] as LoadingType]}</>;
        } else if (property === "billOfLading") {
            return <>{Utils.renderBooleanYesNoValue(row[property], false)}</>;
        }
        return row[property];
    }

    private get isValid(): boolean {
        this.state.selectedYear.validate();
        this.state.selectedMonth.validate();

        return this.state.selectedYear.isValid && this.state.selectedMonth.isValid;
    }


    private get yearsToDropDownMap(): DropDownModel[] {
        return Utils.range(new Date().getFullYear() - 10, new Date().getFullYear()).map(i => {
            return {id: `${i}`, name: `${i}`};
        });
    }

    private get monthsToDropDownMap(): DropDownModel[] {
        return Utils.range(1, 12).map(i => {
            return {
                id: `${i}`, name: i18n.t("months." + DateUtils.getMonthName(i))
            };
        });
    }

    private async onGenerateReport() {
        this.setState({generatedReportResponse: undefined});
        const paginationStore = this.context.paginationStore as IPaginationStore;

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});

            const filters = {
                year: this.state.selectedYear.value,
                month: this.state.selectedMonth.value
            };

            const generatedReportResponse = await SeaFerriesSummaryService.generateReport(
                filters
            );

            this.setState({
                isSubmitButtonBlocked: false,
                generatedReportResponse,
                generatedReport: generatedReportResponse?.data?.data || null,
                isReportGenerated: true,
                currentPage: generatedReportResponse?.data?.currentPage
            });

            paginationStore.setNumberOfElements(generatedReportResponse?.data?.numberOfElements);
            paginationStore.setNumberOfPages(generatedReportResponse?.data?.numberOfPages);
        }

        Utils.scrollToFirstErrorMessage();
    }
}